module.exports = __webpack_public_path__ + "static/img/14000670.6bc5aefc.png";